/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Home_Elsewhere_DescInputs */



/**
* | output |
* | --- |
* | "Any other online venue. Without the bot, check-in and results stay in the app." |
*
* @param {Tournament_Wiz_Home_Elsewhere_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_home_elsewhere_desc = /** @type {((inputs?: Tournament_Wiz_Home_Elsewhere_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Home_Elsewhere_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout autre lieu en ligne. Sans le bot, le pointage et les résultats se font dans l'app.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cualquier otro lugar en línea. Sin el bot, el check-in y los resultados se hacen en la app.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Qualquer outro local online. Sem o bot, check-in e resultados ficam no app.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Qualsiasi altro luogo online. Senza il bot, check-in e risultati si fanno nell'app.")
	return /** @type {LocalizedString} */ ("Any other online venue. Without the bot, check-in and results stay in the app.")
});